<script>
  import { CanvasCapture } from "canvas-capture";
  import AppIconDraw from "./AppIconDraw.svelte";
  import ImgFullPreview from "./ImgFullPreview.svelte";
  import Settings from "./Settings.svelte";
  import BrushSettings from "./draw/BrushSettings.svelte";
  import filterNames from "./utils/filters.js";
  // import { Stack } from "@datastructures-js/stack";
  import { onMount } from "svelte";

  import {
    Button,
    FormGroup,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
  } from "sveltestrap";
  import AppAllPreset from "./AppAllPreset.svelte";
  import AppFilterDraw from "./AppFilterDraw.svelte";
  import CanvasLayers from "./CanvasLayers.svelte";
  import Collapsed from "./Collapsed.svelte";
  import ImageFilters from "./ImageFilters";
  import { getAllPreset, putPreset } from "./db.js";
  import DashStrokeSettings from "./draw/DashStrokeSettings.svelte";
  import FontSettings from "./draw/FontSettings.svelte";
  import GradientSettings from "./draw/GradientSettings.svelte";
  import PatternSettings from "./draw/PatternSettings.svelte";
  import StrokeSettings from "./draw/StrokeSettings.svelte";
  import ColorPicker from "./draw/color-picker/ColorPicker.svelte";
  import store from "./store.js";
  import storeSetting from "./storeSettings.js";
  import IFabric from "./utils/fabric-helper.js";
  import l from "./utils/locale";
  import { _err, _log } from "./utils/logger.js";
  import {
    base64Resize,
    dateToLocaleString,
    ratioHeight,
    reverseDigits,
  } from "./utils/util.js";

  const MAX_VALUE_INPUT = 200;
  export let options = {};
  let recordProgess = 0;
  let submenuEl;
  let isRecord = false;
  let isCancelRecord = false;
  let isShowSettings = false;
  let stack = [];
  let stackLength = 1;
  let currentPosition = 1;
  let rangeLength = 1;
  let canvasDraw;
  let canvasF;
  let fabricHelper;
  let w = window.innerWidth - 290;
  let h =
    window.innerHeight > 400
      ? window.innerHeight - 120
      : window.innerHeight - 51;
  let typeBrush = "Pencil";
  let drawTextColor = "";
  let drawWidth = 1;
  let drawOpacity = 10;
  let recordImage;
  let drawShadowY = 5;
  let drawShadowX = 5;
  let drawShadowColor = "#545454";
  let drawShadowBlur = 10;
  let drawFontSize = 30;
  let settingDelay = 0;
  let settingSpeed = 0;
  let isDrawStrokeDash = false;
  let isFirstLoad = true;
  let drawOpacityStroke = 10;
  let drawColor = "#333";
  let drawStrokeColor = "#333";
  let drawStrokeLineCap = "butt";
  let typeShape = "";
  let popoverMode = "";
  let isShadow = false;
  let isPattern = false;
  let isScaleStroke = false;
  let isRound = false;
  let drawStrokeDash = false;
  let type = "shape";
  let settingWidth = 512;
  let isUpdateCanvas = true;
  const modes = ["fills", "center", "left", "right"];
  let currentMode = "center";
  let imgFullPreview = "";
  let isShowAllPreset = false;
  let isShowModalErase = false;
  let allPreset = [];
  let _canvas;
  let filterApplyCount = 0;
  let id = dateToLocaleString();
  let canvasResize;
  let contextResize;
  let currentFilterLayer = "all layers";

  $: if (fabricHelper) {
    fabricHelper.setTypeShape(typeShape);
  }

  $: if (window.fabricHelper) {
    if (!isFirstLoad) {
    }
    window.fabricHelper.updateActiveShadow(
      drawShadowColor,
      drawShadowBlur,
      drawShadowX,
      drawShadowY
    );
  }

  function updateCanvas() {
    if (isUpdateCanvas) {
      window.fabricHelper.updateActive();
      canvasF.requestRenderAll();
      _log("updateCanvas()");
      window.requestAnimationFrame(updateCanvas);
    }
  }
  async function loadPreset() {
    try {
      allPreset = await getAllPreset();
      _log("loadPreset()", allPreset);
    } catch (error) {
      _err(error);
      allPreset = [];
    }
  }

  function initCanvasF() {
    canvasF = new fabric.Canvas(canvasDraw, {
      preserveObjectStacking: true,
      width: w,
      height: h,
      selectable: false,
      uniScaleTransform: true,
    });
    fabricHelper = new IFabric(canvasF, (objs) => {
      _log("FABRIC", objs);
    });
    window.fabricHelper = fabricHelper;
    window.canvasF = canvasF;
    canvasF.on("object:removed", (e) => {
      const target = e.target;
      _log("object:removed", e.target.id, stackLength);
      stack = stack.filter((v) => v.id !== target.id);
      stackLength = stack.length;
      rangeLength = stack.length;
    });
    canvasF.on("object:added", (e) => {
      const target = e.target;
      if (!e.target.id) {
        e.target.id = Date.now();
      }
      stack.push(target);
      stackLength = stack.length;
      rangeLength = stack.length;
      _log("object:added", e.target.id, stackLength);
    });
  }

  function onChangeSlider(e) {
    const value = e.detail.value - 1;
    currentPosition = value;
    _log("onChangeSlider", value);
    stack.forEach((el, i) => {
      if (i > value) {
        el.opacity = 0;
      } else {
        el.opacity = 1;
      }
    });
    canvasF.discardActiveObject().requestRenderAll();
  }

  onMount(() => {
    initCanvasF();

    if (window["appIsDBREady"]) {
      loadPreset();
    } else {
      setTimeout(() => {
        loadPreset();
      }, 1000);
    }

    _log("storeSetting", storeSetting.getStore());
    const unsubscribeSettingStore = storeSetting.subscribe((s) => {
      settingWidth = s.settingWidth;
      settingDelay = s.settingDelay;
      settingSpeed = s.settingSpeed;
    });

    const unsubscribe = store.subscribe((s) => {
      type = s.type;
      IFabric.setStore(s);
      drawFontSize = s.drawFontSize;
      let isUpdate = false;
      if (drawWidth !== s.drawWidth) {
        isUpdate = "drawWidth";
      }
      drawWidth = s.drawWidth;

      if (drawOpacity !== s.drawOpacity) {
        isUpdate = "drawOpacity";
      }
      drawOpacity = s.drawOpacity;

      drawStrokeDash = s.drawStrokeDash;

      if (isDrawStrokeDash !== s.isDrawStrokeDash) {
        isUpdate = "drawStrokeDash";
      }
      isDrawStrokeDash = s.isDrawStrokeDash;

      isScaleStroke = s.isScaleStroke;

      if (
        (isRound !== s.drawStrokeLineCap) === "round" ||
        drawStrokeLineCap !== s.drawStrokeLineCap
      ) {
        isUpdate = "drawStrokeLineCap";
      }
      drawStrokeLineCap = s.drawStrokeLineCap;
      isRound = s.drawStrokeLineCap === "round";

      isPattern = s.isPattern;

      drawColor = s.drawColor;
      drawStrokeColor = s.drawStrokeColor;

      drawOpacityStroke = s.drawOpacityStroke;
      drawShadowColor = s.drawShadowColor;
      drawShadowBlur = s.drawShadowBlur;
      drawShadowY = s.drawShadowY;
      drawShadowX = s.drawShadowX;

      isShadow = s.isShadow;

      popoverMode = s.popoverMode;

      typeBrush = s.typeBrush;
      typeShape = s.typeShape;

      _log("typeBrush", typeBrush);
      _log("typeShape", typeShape);

      _log("drawColor", drawColor);
      _log("drawStrokeColor", drawStrokeColor);

      if (!isFirstLoad) {
        isFirstLoad = false;
      }
      if (isUpdate) {
        window.fabricHelper.updateActive(isUpdate);
      }
      if (typeShape === "brush" && fabricHelper.brush) {
        fabricHelper.brush.updateBrush();
      }
    });
    canvasResize = document.createElement("canvas");
    contextResize = canvasResize.getContext("2d");
    addListeners();
    return () => {
      isUpdateCanvas = false;
      unsubscribe();
      unsubscribeSettingStore();
    };
  });

  function addListeners() {
    document.addEventListener(
      "keyup",
      (event) => {
        const keyName = event.key;
        _log("keyName", keyName);
        switch (keyName) {
          case "1":
            newSquareHandler();
            break;
          case "2":
            newCircleHandler();
            break;
          case "3":
            newTriangleHandler();
            break;
          case "4":
            newPolygonHandler();
            break;
          case "5":
            newLineHandler();
            break;
          case "b":
            newBrushHandler();
            break;
          case "t":
            newTextHandler();
            break;
          case "s":
            onClickSavePreset();
            break;
          case "ArrowLeft":
            leftmousedownHandler();
            break;
          case "ArrowRight":
            rightmousedownHandler();
            break;
          case "ArrowDown":
            downmousedownHandler();
            break;
          case "ArrowUp":
            upmousedownHandler();
            break;
          case "l":
            onClickLayer();
            break;
          case "p":
            onClickLoadPreset();
            break;
          case "c":
            onClickCopy();
            break;
          case "i":
            onClickUpload();
            break;
          case "Delete":
            onClickUndo();
            break;
          // case 'r': onClickRecordDraw(); break;
          case "v":
            transformHandler();
            break;
        }
      },
      false
    );
  }

  function onInputHandler(e) {
    store.setValue(e.target.name, e.target.value);
  }

  function onInputHandlerInt(e) {
    store.setValue(e.target.name, +e.target.value);
  }

  function onClickRandomColor(e) {
    store.setValue("drawBrushRandomColor", e.target.checked);
  }

  // function onClickErase() {
  //     window.fabricHelper.removeActive();
  // }

  function newTextHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "text");
    scrollSubmenuToTop();
  }

  function newBrushHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }

    store.setValue("typeShape", "brush");
    scrollSubmenuToTop();
  }

  function newLineHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "line");
  }

  function newSquareHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "square");
    scrollSubmenuToTop();
  }

  function newPolygonHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "polygon");
  }

  function newCircleHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "circle");
  }

  function newTriangleHandler() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("shape");
    }
    store.setValue("typeShape", "triangle");
  }

  let isTransform = false;
  function transformHandler() {
    canvasF.discardActiveObject().renderAll();
    store.setValue("typeShape", "---");
    isTransform = true;
  }

  function onClickScreenshot() {
    const drawCanvas = window.fabricHelper.getCanvas();
    if (drawCanvas) {
      const type = "image/png";
      const url = drawCanvas.toDataURL();
      const imageName = dateToLocaleString();
      const link = document.createElement("a");
      link.setAttribute("href", url.replace(type, "image/octet-stream"));
      const _fileName = `${imageName}.png`;
      link.setAttribute("download", _fileName);
      link.click();
    }
  }

  function onClickForward() {
    isTransform = true;
    fabricHelper.selectionFront();
  }

  function onClickBackward() {
    isTransform = true;
    fabricHelper.selectionBack();
  }

  function onClickUndo() {
    isTransform = true;
    fabricHelper.removeLast();
  }

  function scrollSubmenuToTop() {
    setTimeout(() => {
      if (submenuEl) {
        submenuEl.scrollTo({ top: 0 });
      }
    }, 0);
  }

  function onClickLayer() {
    isTransform = true;
    store.setValue("typeShape", "layer");
    scrollSubmenuToTop();
  }

  function onClickCopy() {
    isTransform = true;
    setTimeout(() => {
      fabricHelper.lastSelectionCopy();
    }, 0);
  }

  function onClickUpload() {
    canvasF.discardActiveObject().renderAll();
    isTransform = false;
    if (type !== "shape") {
      store.setType("filter");
    }
    store.setValue("typeShape", "filter");
    const fileInput = document.createElement("input");
    fileInput.setAttribute("type", "file");
    fileInput.setAttribute("accept", "image/*");
    fileInput.setAttribute("multiple", "true");
    fileInput.onchange = () => {
      const fileList = fileInput.files;
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        _log("file.type", file.type, file.name);
        if (file.type) {
          if (file.type.includes("image/")) {
            window.fabricHelper.newImage(file, "", {}, (obj) => {
              //window.fabricHelper.selectLastActiveObject();
              scrollSubmenuToTop();
            });
          }
        }
      }
    };
    fileInput.click();
  }

  function _applyFilters(v, img) {
    if (!_canvas) {
      _canvas = document.createElement("canvas");
    }
    filterApplyCount += 1;
    function apply(count) {
      setTimeout(() => {
        if (filterApplyCount === count) {
          _canvas.width = img.width;
          _canvas.height = img.height;
          const ctx = _canvas.getContext("2d");
          // ctx.globalAlpha = 1;
          ctx.clearRect(0, 0, _canvas.width, _canvas.height);
          ctx.drawImage(img, 0, 0, _canvas.width, _canvas.height);
          let isFilter = false;
          for (let key of Object.keys(filters)) {
            if (key !== "opacity") {
              if (filters[key] > 0) {
                isFilter = true;
              }
              _log("filter value", key, filters[key]);
            }
          }
          if (Number.isInteger(filters.opacity)) {
            const opacityValue = reverseDigits(filters.opacity) / 10;
            _log("opacityValue", opacityValue);
            //ctx.globalAlpha = opacityValue;
            v.set("opacity", opacityValue);
          }

          if (isFilter) {
            ImageFilters.applyFilters(_canvas, ctx, filters, false, true);
          } else {
            _log("no filters");
          }
          _log("filters", filters);
          v.setElement(_canvas);

          window.fabricHelper.render();
        }
      }, 500);
    }
    apply(filterApplyCount);
  }

  function applyFilters() {
    const ao = canvasF.getActiveObjects();

    if (ao) {
      ao.forEach((v) => {
        _log("filters", filters);
        _log("v", v);

        let img = v.img;

        if (img) {
          _applyFilters(v, img);
        } else {
          _log("no image");
          const file = v.toDataURL();
          _log("v file", file);
          canvasF.remove(v);
          window.fabricHelper.newImage(
            file,
            {},
            filters,
            (obj) => {
              obj.left = v.left;
              obj.top = v.top;
              obj.width = v.width;
              obj.height = v.height;

              // canvas.add(obj);
              window.fabricHelper.selectLastActiveObject();
              _applyFilters(obj, obj.img);
            },
            true
          );
        }
      });
    } else {
      _log("applyFilters() no objs");
    }
  }

  let filters = {};
  const onChangeFilter = ({ detail: { name, value } }) => {
    _log("onChangeFilter", name, value);

    // const _filters = { ..._filters };
    // _filters[name] = Number(value);
    // if(lastUploadImage){
    //     lastUploadImage.
    // }
    // applyFilter(_filters);
    filters[name] = parseInt(value, 10);
    applyFilters();
    // store.setValue("typeShape", "---");
  };

  function onChangeMode(e) {
    const val = e.target.value;
    currentMode = val;
    window["appDrawMode"] = currentMode;
    _log("onChangeMode", val);
  }

  function showImage(img) {
    imgFullPreview = img;
  }

  function onClickImage() {
    imgFullPreview = "";
  }

  function onClickLoadPreset() {
    isShowAllPreset = true;
  }

  function* loopFrame(array) {
    for (let i = 0; i < array.length; i++) {
      const el = array[i];
      el.opacity = 1;
      canvasF.requestRenderAll();
      CanvasCapture.checkHotkeys();
      if (CanvasCapture.isRecording()) CanvasCapture.recordFrame();
      yield i;
    }
  }

  function getImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve(img);
      };
      img.onerror = () => {
        reject();
      };
      img.src = url;
    });
  }

  async function onClickSavePreset() {
    const drawCanvas = window.fabricHelper.getCanvas();
    let drawImage;
    let preview;
    if (drawCanvas) {
      drawImage = JSON.stringify(drawCanvas);
      preview = drawCanvas.toDataURL();
    }
    const preset = { ...options };
    preset.drawImage = drawImage;
    preset.drawMode = currentMode;

    try {
      const h = ratioHeight(drawCanvas.width, drawCanvas.height, 300);
      preview = await base64Resize(preview, {
        width: 300,
        height: h,
        quality: 100,
        type: "png",
      });
    } catch (error) {
      _err(error);
    }
    preset.preview = preview;

    preset.id = id;
    const result = await putPreset({ id, preset });
    if (result) {
      isShowAllPreset = false;
      loadPreset();
    }
  }

  function applePresetNew() {
    id = dateToLocaleString();
    clearAllDrawCanvas();
  }

  function onApplyPreset(e) {
    isShowAllPreset = false;
    const preset = e.detail;
    if (window.fabricHelper) {
      const canvas = window.fabricHelper.getCanvas();
      canvas.loadFromJSON(preset.drawImage);
      if (preset.drawMode) {
        currentMode = preset.drawMode;
        window["appDrawMode"] = currentMode;
        id = preset.id;
      }
      _log("onApplyPreset", preset);
    }
  }

  function clearDrawCanvas() {
    const ao = canvasF.getActiveObjects();
    //this.canvasF.discardActiveObject()
    _log("clearDrawCanvas", ao);
    if (ao && ao.length > 0) {
      ao.forEach((o) => {
        o.selectable = false;
        canvasF.remove(o);
      });
      window.fabricHelper.render();
    } else {
      const ao = canvasF.getObjects();
      if (ao && ao.length > 0) {
        isShowModalErase = true;
      }
    }
  }

  function clearAllDrawCanvas() {
    const ao = canvasF.getObjects();
    _log("clearAllDrawCanvas", ao);
    if (ao && ao.length > 0) {
      ao.forEach((o) => {
        canvasF.remove(o);
      });
      window.fabricHelper.render();
    }
    isShowModalErase = false;
  }

  function cancelHandler() {
    isCancelRecord = true;
  }

  function onClickSettings() {
    isShowSettings = true;
  }

  function onResize(e) {
    w = window.innerWidth - 270;
    h = window.innerHeight - 120;
    canvasF.setWidth(w);
    canvasF.setHeight(h);
  }
</script>

<div class="main-draw">
  <div class="draw-btns-bottom">
    <Button color="primary" class="roundedBtn" on:click={transformHandler}>
      <AppIconDraw name="cursor" />
    </Button>
    <Button color="danger" class="roundedBtn" on:click={clearDrawCanvas}>
      <AppIconDraw name="clear" />
    </Button>
    <Button color="success" class="rounded" on:click={onClickLoadPreset}>
      <AppIconDraw name="load-preset" />
      <!-- {l["apply_drawing"]} -->
    </Button>
    <Button color="warning" class="rounded" on:click={onClickSavePreset}>
      <AppIconDraw name="save-preset" />
      <!-- {l["save_drawing"]} -->
    </Button>
    <Input
      on:change={onChangeMode}
      id="drawMode"
      name="drawMode"
      type="select"
      value={currentMode}
    >
      {#each modes as item}
        <option value={item}>{l[item]}</option>
      {/each}
    </Input>
  </div>
  <div id="menu-draw">
    <Button
      color={typeShape === "brush" ? "primary" : "secondary"}
      class="roundedBtn"
      on:click={newBrushHandler}
    >
      <AppIconDraw name="brush" />
    </Button>

    <Button
      color={typeShape === "square" ? "primary" : "secondary"}
      class="roundedBtn"
      on:click={newSquareHandler}
    >
      <AppIconDraw name="square" />
    </Button>

    <Button
      color={typeShape === "text" ? "primary" : "secondary"}
      class="roundedBtn"
      on:click={newTextHandler}
    >
      <AppIconDraw name="text" />
    </Button>
    <Button
      color={typeShape === "filter" ? "primary" : "secondary"}
      class="roundedBtn"
      on:click={onClickUpload}
    >
      <AppIconDraw name="upload" />
    </Button>
    <Button
      color={typeShape === "layer" ? "primary" : "secondary"}
      class="roundedBtn btnClear"
      on:click={onClickLayer}
    >
      <AppIconDraw name="layer" />
    </Button>
    <Button
      color="secondary"
      class="roundedBtn btnClear"
      on:click={onClickUndo}
    >
      <AppIconDraw name="undo" />
    </Button>
    <Button
      color="secondary"
      class="roundedBtn btnClear"
      on:click={onClickCopy}
    >
      <AppIconDraw name="copy" />
    </Button>

    <Button
      color="secondary"
      class="roundedBtn btnClear"
      on:click={onClickForward}
    >
      <AppIconDraw name="forward" />
    </Button>
    <Button
      color="secondary"
      class="roundedBtn btnClear"
      on:click={onClickBackward}
    >
      <AppIconDraw name="backward" />
    </Button>

    <Button
      color="secondary"
      class="roundedBtn btnClear"
      on:click={onClickScreenshot}
    >
      <AppIconDraw name="screenshot" />
    </Button>
  </div>
  <div id="draw-canvas-submenu" bind:this={submenuEl}>
    {#if typeShape === "layer"}
      <Collapsed name="layer" />
      <CanvasLayers />
    {/if}
    {#if typeShape === "square" || typeShape === "circle" || typeShape === "triangle" || typeShape === "polygon" || typeShape === "line"}
      <!-- <Collapsed name="brush" /> -->
      <Collapsed name="shape" />

      <div class="flex collapsable">
        <div class="shape-box">
          <Button
            color={typeShape === "square" ? "primary" : "secondary"}
            class="roundedBtn"
            on:click={newSquareHandler}
          >
            <AppIconDraw name="square" />
          </Button>

          <Button
            color={typeShape === "circle" ? "primary" : "secondary"}
            class="roundedBtn"
            on:click={newCircleHandler}
          >
            <AppIconDraw name="circle" />
          </Button>
          <Button
            color={typeShape === "triangle" ? "primary" : "secondary"}
            class="roundedBtn"
            on:click={newTriangleHandler}
          >
            <AppIconDraw name="triangle" />
          </Button>
          <Button
            color={typeShape === "polygon" ? "primary" : "secondary"}
            class="roundedBtn"
            on:click={newPolygonHandler}
          >
            <AppIconDraw name="star" />
          </Button>
          <Button
            color={typeShape === "line" ? "primary" : "secondary"}
            class="roundedBtn"
            on:click={newLineHandler}
          >
            <AppIconDraw name="line" />
          </Button>
        </div>
      </div>
    {/if}

    {#if typeShape === "brush"}
      <!-- <Collapsed name="brush" /> -->
      <Collapsed name="brush" />
      <div class="flex collapsable">
        <div class="brushRange">
          <BrushSettings />
          <FormGroup>
            <Input
              type="checkbox"
              label={l["random_color"]}
              on:input={onClickRandomColor}
            />
          </FormGroup>
        </div>
      </div>
    {:else if typeShape === "text"}
      <Collapsed name="font" />
      <div class="flex collapsable">
        <div class="rangeRange">
          <div class="leftLabel">
            {l["size"]}
            {drawFontSize || ""}
          </div>
          <Input
            class="range-filters"
            on:input={onInputHandlerInt}
            on:change={onInputHandlerInt}
            bind:value={drawFontSize}
            id="drawFontSize"
            min={1}
            max={100}
            name="drawFontSize"
            type="range"
          />
        </div>
        <FontSettings />
      </div>
    {/if}
    {#if typeShape !== "line" && typeShape !== "brush"}
      <Collapsed name="fill" />
      <div class="flex collapsable">
        <div class="popover-controls flex-jc mt-2">
          <div class="flex mb-2">
            <ColorPicker id="drawColor" />
            <PatternSettings id="fill" />
            <GradientSettings id="fill" />
          </div>
          {#if typeShape === "line"}
            <div class="rangeRange">
              <div class="leftLabel">
                {l["w"]}
                {drawWidth || ""}
              </div>
              <Input
                class="range-filters"
                on:input={onInputHandlerInt}
                on:change={onInputHandlerInt}
                bind:value={drawWidth}
                min={1}
                max={MAX_VALUE_INPUT}
                name="drawWidth"
                type="range"
              />
            </div>
          {/if}

          <div class="rangeRange">
            <div class="leftLabel">
              {l["visibility"]}
              {drawOpacity * 10 || ""}
            </div>
            <Input
              class="range-filters"
              on:input={onInputHandlerInt}
              on:change={onInputHandlerInt}
              bind:value={drawOpacity}
              min={0}
              step={0.1}
              max={1}
              name="drawOpacity"
              type="range"
            />
          </div>
        </div>
      </div>
    {/if}
    <Collapsed name="stroke" />
    <div class="flex collapsable">
      <div class="popover-controls flex-jc mt-2">
        <div class="flex mb-2">
          <ColorPicker id="drawStrokeColor" />
          <div
            style={typeBrush !== "Pencil" && typeShape === "brush"
              ? "display:none"
              : "display:block"}
          >
            <PatternSettings id="stroke" />
          </div>
          <div
            style={typeBrush !== "Pencil" && typeShape === "brush"
              ? "display:none"
              : "display:block"}
          >
            <GradientSettings id="stroke" />
          </div>
        </div>
        <div class="rangeRange">
          <div class="leftLabel">
            {l["w"]}
            {drawWidth || ""}
          </div>
          <Input
            class="range-filters"
            on:input={onInputHandlerInt}
            on:change={onInputHandlerInt}
            bind:value={drawWidth}
            min={0}
            max={MAX_VALUE_INPUT}
            name="drawWidth"
            type="range"
          />
        </div>
        {#if typeShape === "line"}
          <div class="rangeRange">
            <div class="leftLabel">
              {l["visibility"]}
              {drawOpacity * 10 || ""}
            </div>
            <Input
              class="range-filters"
              on:input={onInputHandlerInt}
              on:change={onInputHandlerInt}
              bind:value={drawOpacity}
              min={0}
              step={0.1}
              max={1}
              name="drawOpacity"
              type="range"
            />
          </div>
        {/if}
        <StrokeSettings />
      </div>
      {#if isDrawStrokeDash}
        <DashStrokeSettings />
      {/if}
    </div>

    <Collapsed name="shadow" />
    <div class="flex collapsable">
      <div class="popover-controls flex-jc mt-2">
        <ColorPicker id="drawShadowColor" />
        <div class="rangeRange mt-2">
          <div class="leftLabel">
            {l["blur"]}
            {drawShadowBlur || ""}
          </div>
          <Input
            class="range-filters"
            on:input={onInputHandlerInt}
            on:change={onInputHandlerInt}
            bind:value={drawShadowBlur}
            min={0}
            max={MAX_VALUE_INPUT}
            name="drawShadowBlur"
            type="range"
          />
        </div>
        <div class="rangeRange">
          <div class="leftLabel">
            {"x"}
            {drawShadowX}
          </div>
          <Input
            class="range-filters"
            on:input={onInputHandlerInt}
            on:change={onInputHandlerInt}
            bind:value={drawShadowX}
            min={-100}
            max={100}
            id="drawShadowX"
            name="drawShadowX"
            type="range"
          />
        </div>
        <div class="rangeRange">
          <div class="leftLabel">
            {"y"}
            {drawShadowY}
          </div>
          <Input
            class="range-filters"
            on:input={onInputHandlerInt}
            on:change={onInputHandlerInt}
            bind:value={drawShadowY}
            min={-100}
            max={100}
            id="drawShadowY"
            name="drawShadowY"
            type="range"
          />
        </div>
      </div>
    </div>
    {#if typeShape === "filter" || typeShape === "---"}
      <Collapsed name="filter" />
      <div class="flex collapsable">
        {#each filterNames as filter}
          <AppFilterDraw {filter} on:change={onChangeFilter} name={filter} />
        {/each}
      </div>
    {/if}
  </div>

  <canvas bind:this={canvasDraw} width={w} height={h} class="canvas_fit" />
</div>

{#if isShowAllPreset}
  <AppAllPreset
    bind:isShowAllPreset
    bind:allPreset
    on:applePreset={onApplyPreset}
    on:applePresetNew={applePresetNew}
  />
{/if}

<Modal isOpen={isShowModalErase}>
  <ModalHeader toggle={isShowModalErase}>{l["remove_all_objects"]}</ModalHeader>
  <ModalBody>{l["remove_all_objects_message"]}</ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={clearAllDrawCanvas}
      >{l["clear_all"]}</Button
    >
    <Button
      color="secondary"
      on:click={() => {
        isShowModalErase = false;
      }}>{l["cancel"]}</Button
    >
  </ModalFooter>
</Modal>

{#if recordImage}
  <ImgFullPreview
    img={recordImage}
    on:close={() => {
      recordImage = null;
    }}
  />
{/if}
{#if isShowSettings}
  <Settings
    on:close={() => {
      isShowSettings = false;
    }}
  />
{/if}
